export default __webpack_public_path__ + "static/media/loginLogo.60bd3852.png";